<ion-header class="ion-no-border">

  <ion-toolbar>
        <ion-buttons slot="start">
      <!-- <ion-menu-button></ion-menu-button> -->
      <ion-back-button defaultUrl="/stallion"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="login-content">
  <h2 class="auth-title">
    {{'SIGNIN_TITLE' | translate}}
    <br/>
  </h2>
  <form [formGroup]="loginForm" (ngSubmit)="signInWithEmail()">
    <ion-list class="inputs-list" lines="full">
      <ion-item class="input-item">
        <ion-input type="email" placeholder="Email" formControlName="email" clearInput autocapitalize="off" inputmode="email"></ion-input>
      </ion-item>
      <div class="error-container">
        <ng-container *ngFor="let validation of validation_messages.email">
          <div class="error-message" *ngIf="loginForm.get('email').hasError(validation.type) && (loginForm.get('email').dirty || loginForm.get('email').touched)">
            <ion-icon name="information-circle-outline"></ion-icon>
            <span>{{ validation.message }}</span>
          </div>
        </ng-container>
      </div>

      <ion-item class="input-item">
        <app-show-hide-password>
          <ion-input type="password" placeholder="Password" formControlName="password"></ion-input>
        </app-show-hide-password>
      </ion-item>
      <div class="error-container">
        <ng-container *ngFor="let validation of validation_messages.password">
          <div class="error-message" *ngIf="loginForm.get('password').hasError(validation.type) && (loginForm.get('password').dirty || loginForm.get('password').touched)">
            <ion-icon name="information-circle-outline"></ion-icon>
            <span>{{ validation.message }}</span>
          </div>
        </ng-container>
      </div>
    </ion-list>

    <ion-button class="login-btn" type="submit" expand="block" [disabled]="!loginForm.valid">{{'SIGNIN_LOGIN' | translate}}</ion-button>
    <div class="error-container" *ngIf="submitError">
      <div class="error-message">
        <ion-icon name="information-circle-outline"></ion-icon>
        <span>{{ submitError }}</span>
      </div>
    </div>
    <ion-row class="other-auth-options-row">
      <ion-button class="signup-btn" fill="clear" [routerLink]="['/login/auth/sign-up']">
        {{'SIGNIN_REGISTER' | translate}}
      </ion-button>
    </ion-row>
  </form>

  <div class="social-auth-options">
    <p class="options-divider">Or</p>
    <!-- <ion-button class="social-auth-btn facebook-auth-btn" expand="block" color="facebook" (click)="doFacebookLogin()">Log In with Facebook</ion-button> -->
    <ion-button class="social-auth-btn google-auth-btn" expand="block" color="google" (click)="doGoogleLogin()">Log In with Google</ion-button>
    <!-- <ion-button class="social-auth-btn twitter-auth-btn" expand="block" color="twitter" (click)="doTwitterLogin()">Log In with Twitter</ion-button> -->
  </div>
</ion-content>
